import apiClient from '@/services/axios'

export async function put(event) {

  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/events/' + event.eventId.id, event);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to put event.')
}
